import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { FilterToolbarModule } from "@vp/shared/components/filter-toolbar";
import { FlexModule } from "@vp/shared/directives/flex";
import { DynamicFilterTermModule } from "@vp/shared/pipes/dynamic-filter-term";
import { DynamicAssignmentComponent } from "./dynamic-assignment.component";

@NgModule({
  imports: [
    CommonModule,
    FlexModule,
    DynamicFilterTermModule,
    FilterToolbarModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatSlideToggleModule,
    MatSelectModule
  ],
  declarations: [DynamicAssignmentComponent],
  exports: [DynamicAssignmentComponent]
})
export class DynamicAssignmentModule {}
